import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteShift($companyId: ID!, $id: ID!) {
    deleteShift(companyId: $companyId, id: $id) {
      shift {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
